<template>
    <tbody colpsan="10">
        <span v-for="(grupo, index) in exibir" :key="index">
            <tr>
                <td colspan="100">{{ index }}</td>
            </tr>
            <relatorio-grupo :dados="grupo" :grupos="next_groups" :columns="columns" v-if="$props.grupos.length > 1"></relatorio-grupo>
            <tr v-else v-for="(row, index) in grupo" :key="index">
                <td v-for="(column, index) in $props.columns" 
                    :key="index">
                    {{ row[column.name] }}
                </td>
            </tr>
        </span>
    </tbody>
</template>

<script>
import _ from 'lodash';

export default {
    data () { 
        return {
            exibir: [],
        }
    },
    props: ['dados', 'grupos', 'columns'],
    computed: { 
        next_groups: function () { 
            return _.slice(this.$props.grupos, 1);
        }
    },
    mounted () { 
        if ( this.$props.grupos && this.$props.grupos.length ) { 
            this.exibir = _.groupBy(this.$props.dados, this.$props.grupos[0].name);
        }
    }
}
</script>